import { GetSiteLocationsApiModel } from "../api-models/get-site-locations.api-model";
import { MasterdataSiteEntity } from "../entities/masterdata-site.entity";
import { SiteLocationCollection } from "../models/site-location-collection";

export abstract class MasterdataSiteRepository {
   public abstract getMasterdataSiteByMasterdataIdAsync(masterdataId: string): Promise<MasterdataSiteEntity>;   
}
